import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import TrustBar from "@/sections/TrustBar";
import About from "@/sections/About";
import Treatments from "@/sections/Treatments";
import Testimonials from "@/sections/Testimonials";
import HowItWorks from "@/sections/HowItWorks";
import Contact from "@/sections/Contact";
import Philosophy from "@/sections/Philosophy";
import FinalCTA from "@/sections/FinalCTA";
import Footer from "@/sections/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import BackToTop from "@/components/BackToTop";
import Ornament from "@/components/Ornament";

const Noblesse = () => {
  return (
    <main className="bg-anthracite-950 text-cream overflow-x-hidden" data-testid="noblesse-landing">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <TrustBar />
      <Ornament className="py-6 bg-anthracite-950" />
      <About />
      <Ornament className="py-6 bg-anthracite-900" />
      <Treatments />
      <Ornament className="py-6 bg-anthracite-950" />
      <Testimonials />
      <Ornament className="py-6 bg-anthracite-900" />
      <HowItWorks />
      <Ornament className="py-6 bg-anthracite-950" />
      <Contact />
      <Philosophy />
      <FinalCTA />
      <Footer />
      <BackToTop />
    </main>
  );
};

export default Noblesse;
